<template>
  <main>
    <div class="page-content">
      <div class="container-fluid">
        <div class="row">
           <div class="col-12">
              <div class="page-title-box d-flex align-items-center justify-content-between">
                 <h4 class="mb-0 font-size-18">Installed Plugins </h4>
                 <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                       <li class="breadcrumb-item"><a href="javascript: void(0);">Your Server</a></li>
                       <li class="breadcrumb-item active">Installed Plugins</li>
                    </ol>
                 </div>
              </div>
           </div>
        </div>
        <!-- end page title -->
        <div class="row">
           <div class="col-lg-12">
              <div class="">
                 <div class="table-responsive">
                    <table class="table project-list-table table-nowrap table-centered table-borderless">
                       <form class="app-search d-none d-lg-block">
                          <div class="position-relative">
                             <input type="text" class="form-control" placeholder="Search here to browse installed plugins...">
                          </div>
                       </form>
                       <thead>
                          <tr>
                             <th scope="col">Plugin Name </th>
                             <th scope="col">Author</th>
                             <th scope="col">Installed Version</th>
                             <th scope="col">Action</th>
                          </tr>
                       </thead>
                       <tbody>
                          <tr>
                             <td>
                                <h5 class="text-truncate font-size-14"><a href="#" class="text-dark">TreeCapitator</a></h5>
                             </td>
                             <td>Compgeek28</td>
                             <td>1.0</td>
                             <td>
                                <button type="button" class="btn btn-danger waves-effect waves-light">
                                <i class="bx bxs-x-square font-size-16 align-middle mr-2"></i> Remove
                                </button>
                             </td>
                          </tr>
                          <tr>
                             <td>
                                <h5 class="text-truncate font-size-14"><a href="#" class="text-dark">GalacticPanel</a></h5>
                             </td>
                             <td>Compgeek28</td>
                             <td>1.1.4</td>
                             <td>
                                <button type="button" class="btn btn-danger waves-effect waves-light">
                                <i class="bx bxs-x-square font-size-16 align-middle mr-2"></i> Remove
                                </button>
                             </td>
                          </tr>
                          <tr>
                             <td>
                                <h5 class="text-truncate font-size-14"><a href="#" class="text-dark">TechnicalHealth</a></h5>
                             </td>
                             <td>Techknowsitall</td>
                             <td>BETA 1.3</td>
                             <td>
                                <button type="button" class="btn btn-danger waves-effect waves-light">
                                <i class="bx bxs-x-square font-size-16 align-middle mr-2"></i> Remove
                                </button>
                             </td>
                          </tr>
                          <tr>
                             <td>
                                <h5 class="text-truncate font-size-14"><a href="#" class="text-dark">Instant Respawn</a></h5>
                             </td>
                             <td>Compgeek28</td>
                             <td>1.07</td>
                             <td>
                                <button type="button" class="btn btn-danger waves-effect waves-light">
                                <i class="bx bxs-x-square font-size-16 align-middle mr-2"></i> Remove
                                </button>
                             </td>
                          </tr>
                          <tr>
                             <td>
                                <h5 class="text-truncate font-size-14"><a href="#" class="text-dark">TreeCapitator</a></h5>
                             </td>
                             <td>Compgeek28</td>
                             <td>1.0</td>
                             <td>
                                <button type="button" class="btn btn-danger waves-effect waves-light">
                                <i class="bx bxs-x-square font-size-16 align-middle mr-2"></i> Remove
                                </button>
                             </td>
                          </tr>
                          <tr>
                             <td>
                                <h5 class="text-truncate font-size-14"><a href="#" class="text-dark">TreeCapitator</a></h5>
                             </td>
                             <td>Compgeek28</td>
                             <td>1.0</td>
                             <td>
                                <button type="button" class="btn btn-danger waves-effect waves-light">
                                <i class="bx bxs-x-square font-size-16 align-middle mr-2"></i> Remove
                                </button>
                             </td>
                          </tr>
                          <tr>
                             <td>
                                <h5 class="text-truncate font-size-14"><a href="#" class="text-dark">TreeCapitator</a></h5>
                             </td>
                             <td>Compgeek28</td>
                             <td>1.0</td>
                             <td>
                                <button type="button" class="btn btn-danger waves-effect waves-light">
                                <i class="bx bxs-x-square font-size-16 align-middle mr-2"></i> Remove
                                </button>
                             </td>
                          </tr>
                       </tbody>
                    </table>
                 </div>
              </div>
           </div>
        </div>
        <!-- end row -->
        <div class="row">
           <div class="col-12">
              <div class="text-center my-3">
                 <a href="javascript:void(0);" class="text-success"><i class="bx bx-loader bx-spin font-size-18 align-middle mr-2"></i> Load more </a>
              </div>
           </div>
           <!-- end col-->
        </div>
        <!-- end row -->
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'InstalledPlugins',
  data () {
    return { }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/panel/InstalledPlugins.vue